import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HeaderSection from "./HeaderSection";
import MobileFilter from "./MobileFilter";
import MobileFilterPills from "./MobileFilterPills";
import { Button } from "@/components/ui/button";
import { ArrowUpDown, SlidersHorizontal } from "lucide-react";
import { useParams } from "next/navigation";
import { SORT_BY_OPTIONS } from "@/constants/filter";
import SortDropdown from "@/components/filter-panel/sort/dropdown";
import ProductListingFilter from "@/components/filter-panel/ProductListing";
export interface sortOption {
  id: string;
  title: string;
}
const ResponsiveContainer = t0 => {
  const $ = _c(61);
  const {
    selectedProductType,
    initialNavigationData,
    showFilterPanel: t1,
    showSortingOptions: t2,
    renderHeader,
    isCollection,
    renderFooter,
    searchParams,
    children
  } = t0;
  const showFilterPanel = t1 === undefined ? true : t1;
  const showSortingOptions = t2 === undefined ? true : t2;
  const params = useParams();
  const slug = params.slug as string;
  const isThemeCake = slug === "theme-cakes";
  const [selectedSort, setSelectedSort] = useState("");
  const [activeModal, setActiveModal] = useState(null);
  let t3;
  let t4;
  if ($[0] !== activeModal) {
    t3 = () => {
      if (activeModal) {
        document.body.classList.add("overflow-hidden");
      }
      return _temp;
    };
    t4 = [activeModal];
    $[0] = activeModal;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setActiveModal(null);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const closeModal = t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = sortId => {
      setSelectedSort(sortId);
      closeModal();
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleSortChange = t6;
  let t7;
  if ($[5] !== searchParams || $[6] !== selectedSort) {
    t7 = <SortDropdown options={SORT_BY_OPTIONS} selectedOption={selectedSort} onOptionChange={handleSortChange} searchParams={searchParams} isMobile={true} />;
    $[5] = searchParams;
    $[6] = selectedSort;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const memoizedDropdown = t7;
  let t8;
  if ($[8] !== renderHeader || $[9] !== selectedProductType || $[10] !== slug) {
    t8 = renderHeader ? renderHeader() : <HeaderSection selectedProductType={selectedProductType} selectedCategoryName={slug} />;
    $[8] = renderHeader;
    $[9] = selectedProductType;
    $[10] = slug;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== initialNavigationData || $[13] !== isCollection || $[14] !== isThemeCake || $[15] !== searchParams || $[16] !== selectedProductType || $[17] !== showFilterPanel) {
    t9 = showFilterPanel && <div className="hidden lg:block lg:w-1/4 sticky top-[160px] self-start z-[30] max-h-[calc(100vh-200px)] overflow-y-auto no-scrollbar pb-10" style={{
      position: "sticky",
      top: "160px"
    }}><ProductListingFilter isCollection={isCollection} isThemeCake={isThemeCake} initialNavigationData={initialNavigationData} searchParams={searchParams} selectedProductType={selectedProductType} /></div>;
    $[12] = initialNavigationData;
    $[13] = isCollection;
    $[14] = isThemeCake;
    $[15] = searchParams;
    $[16] = selectedProductType;
    $[17] = showFilterPanel;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = `w-full ${showFilterPanel ? "lg:w-3/4" : "lg:w-full"} flex flex-col items-center justify-between`;
  let t11;
  if ($[19] !== initialNavigationData || $[20] !== isCollection || $[21] !== isThemeCake || $[22] !== searchParams || $[23] !== selectedProductType || $[24] !== showFilterPanel) {
    t11 = showFilterPanel && <MobileFilterPills isCollection={isCollection} isThemeCake={isThemeCake} initialNavigationData={initialNavigationData} searchParams={searchParams} selectedProductType={selectedProductType} />;
    $[19] = initialNavigationData;
    $[20] = isCollection;
    $[21] = isThemeCake;
    $[22] = searchParams;
    $[23] = selectedProductType;
    $[24] = showFilterPanel;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== children || $[27] !== t10 || $[28] !== t11) {
    t12 = <div id="listing-section" className={t10}>{t11}{children}</div>;
    $[26] = children;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t9) {
    t13 = <div className="flex flex-col space-y-6 w-full max-w-[1440px] mx-auto px-2 lg:px-[45px]"><div className="flex flex-col lg:flex-row lg:space-x-4 w-full items-start justify-between">{t9}{t12}</div></div>;
    $[30] = t12;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== activeModal) {
    t14 = () => {
      if (!activeModal) {
        document.body.classList.remove("overflow-hidden");
      }
    };
    $[33] = activeModal;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== activeModal || $[36] !== initialNavigationData || $[37] !== isCollection || $[38] !== isThemeCake || $[39] !== memoizedDropdown || $[40] !== searchParams || $[41] !== selectedProductType || $[42] !== showFilterPanel || $[43] !== showSortingOptions) {
    t15 = (activeModal === "sort" || activeModal === "filter") && <motion.div key="modal-wrapper" className="fixed inset-0 z-[150] lg:hidden flex flex-col justify-end"><motion.div key="backdrop" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={closeModal} className="fixed inset-0 bg-black/60 z-[140] backdrop-blur-[4px] touch-none" transition={{
        duration: 0.3
      }} /><AnimatePresence mode="wait">{activeModal === "sort" && showSortingOptions && <motion.div key="sort-modal" initial={{
          y: "100%"
        }} animate={{
          y: 0
        }} exit={{
          y: "100%"
        }} transition={{
          type: "spring",
          damping: 32,
          stiffness: 300,
          mass: 1
        }} className="w-full bg-white z-[150] rounded-t-[32px] overflow-hidden flex flex-col max-h-[85vh] shadow-[0_-8px_30px_rgba(0,0,0,0.1)]"><div className="flex justify-center pt-3 pb-1"><div className="w-12 h-1.5 bg-stone-200 rounded-full" /></div><div className="relative w-full"><button onClick={closeModal} className="absolute top-2 right-4 text-stone-400 z-50 p-2 hover:bg-stone-50 rounded-full transition-colors">✕</button><div className="w-full pt-6 px-6 pb-8 overflow-y-auto no-scrollbar scrollbar-hide"><h2 className="text-[18px] font-outfit font-extrabold text-left text-[#303030] mb-6 tracking-tight">Sort By</h2><div className="flex flex-col items-start w-full">{memoizedDropdown}</div></div></div></motion.div>}{activeModal === "filter" && showFilterPanel && <motion.div key="filter-modal" initial={{
          y: "100%"
        }} animate={{
          y: 0
        }} exit={{
          y: "100%"
        }} transition={{
          type: "spring",
          damping: 32,
          stiffness: 300,
          mass: 1
        }} className="w-full bg-white z-[150] rounded-t-[32px] overflow-hidden flex flex-col h-[90vh] shadow-[0_-8px_30px_rgba(0,0,0,0.1)]"><div className="flex justify-center pt-3 pb-1"><div className="w-12 h-1.5 bg-stone-200 rounded-full" /></div><MobileFilter onClose={closeModal} isCollection={isCollection} isThemeCake={isThemeCake} initialNavigationData={initialNavigationData} searchParams={searchParams} selectedProductType={selectedProductType} /></motion.div>}</AnimatePresence></motion.div>;
    $[35] = activeModal;
    $[36] = initialNavigationData;
    $[37] = isCollection;
    $[38] = isThemeCake;
    $[39] = memoizedDropdown;
    $[40] = searchParams;
    $[41] = selectedProductType;
    $[42] = showFilterPanel;
    $[43] = showSortingOptions;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== t14 || $[46] !== t15) {
    t16 = <AnimatePresence mode="wait" onExitComplete={t14}>{t15}</AnimatePresence>;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== t13 || $[49] !== t16 || $[50] !== t8) {
    t17 = <div className="flex flex-col relative min-h-screen ">{t8}{t13}{t16}</div>;
    $[48] = t13;
    $[49] = t16;
    $[50] = t8;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== showFilterPanel || $[53] !== showSortingOptions) {
    t18 = (showFilterPanel || showSortingOptions) && <div className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[92%] max-w-[400px] bg-[#037A6A] shadow-[0_8px_30px_rgb(3,122,106,0.3)] border border-[#037A6A] rounded-2xl flex items-center justify-between h-14 z-30 lg:hidden overflow-hidden pointer-events-auto">{showSortingOptions && <Button onClick={() => setActiveModal("sort")} variant="ghost" className="flex-1 h-full flex items-center justify-center gap-2 transition-all active:scale-95 font-lora font-bold text-sm uppercase tracking-wider rounded-none text-white hover:bg-white/10 active:bg-white/20"><ArrowUpDown size={18} className="text-white" />Sort</Button>}{showSortingOptions && showFilterPanel && <div className="w-[1px] h-6 bg-white/20" />}{showFilterPanel && <Button onClick={() => setActiveModal("filter")} variant="ghost" className="flex-1 h-full flex items-center justify-center gap-2 transition-all active:scale-95 font-lora font-bold text-sm uppercase tracking-wider rounded-none text-white hover:bg-white/10 active:bg-white/20"><SlidersHorizontal size={18} className="text-white" />Filter</Button>}</div>;
    $[52] = showFilterPanel;
    $[53] = showSortingOptions;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] !== renderFooter) {
    t19 = renderFooter ? renderFooter() : null;
    $[55] = renderFooter;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== t17 || $[58] !== t18 || $[59] !== t19) {
    t20 = <>{t17}{t18}{t19}</>;
    $[57] = t17;
    $[58] = t18;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  return t20;
};
export default ResponsiveContainer;
function _temp() {
  document.body.classList.remove("overflow-hidden");
}